export const reset = `
  html {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  *,
  *:after,
  *:before {
    box-sizing: inherit;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  del,
  dfn,
  em,
  font,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  figure,
  form,
  label,
  legend,
  button,
  input,
  textarea {
    border: 0 none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  a,
  button {
    vertical-align: inherit;
  }

  html {
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
  }

  body {
    font-size: 1.6rem;
    overscroll-behavior-x: none;
  }

  img,
  picture,
  video,
  canvas {
    display: block;
    height: auto;
    width: 100%;
  }

  button {
    background-color: transparent;
    border: none;
    border-radius: 0;
  }

  button:not(:disabled) {
    cursor: pointer;
  }

  input[type='submit'],
  input[type='reset'],
  input[type='button'],
  button {
    appearance: button;
    background: none;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    padding: 0;
    user-select: none;
  }

  li {
    list-style-type: none;
  }

  a {
    cursor: pointer;
    line-height: normal;
    text-decoration: none;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  // station tracking pixel override
  .triton-pixel {
    height: 0;
    width: 0;
  }
`;
